import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'lumiere.sidebar.collapsed'

function readStoredCollapsed() {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

export function useSidebarCollapsed() {
  const [collapsed, setCollapsedState] = useState(readStoredCollapsed)

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0')
    } catch {
      // ignore storage failures
    }
  }, [collapsed])

  const setCollapsed = useCallback((value) => {
    setCollapsedState(value)
  }, [])

  const toggleCollapsed = useCallback(() => {
    setCollapsedState((current) => !current)
  }, [])

  return { collapsed, setCollapsed, toggleCollapsed }
}
